import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./Component/utils/ProtectedRoute";
import Home from "./Container/Home";
import OrderOnline from "./Container/Orders/order_online";
import ContactUs from "./Container/ContactUs";
import Stores from "./Container/Stores";
import Profile from "./Container/Account/profile";
import Checkout from "./Container/Checkout";
import AccountOverview from "./Container/Account/account_overview";
import Address from "./Container/Account/address";
import Changepassword from "./Container/Account/changepassword";
import MyOrder from "./Container/Account/myorders";
import UserWallet from "./Container/Account/wallet";
import AboutUs from "./Container/Account/about_us";
import Payment from "./Container/Checkout/payment";
import Orderdetails from "./Container/Account/order_details";
import SearchResult from "./Container/Orders/search";
import Helpsupport from "./Container/Account/help_support";
import ChooseMealData from "./Container/Checkout/choose_meal_date";
import Thankyou from "./Container/Checkout/thankyou";
import Login from "./Container/Login";
import Pages from "./Container/Pages";
import PageNotFound from "./Container/Pages/page_not_found";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "remixicon/fonts/remixicon.css";
import "swiper/css";
import "react-loading-skeleton/dist/skeleton.css";
import BackButtonHandler from "./Component/utils/useBackButtonHandler";
import CateringBooking from "./Container/Pages/catering_booking";
import Catering from "./Container/Pages/catering";
import CateringNew from "./Container/Catering/catering_new";
function App() {
  return (
    <Router>
      <ToastContainer />
      <BackButtonHandler />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<ProtectedRoute element={<Home />} />} />
        <Route path="/stores" element={<ProtectedRoute element={<Stores />} />} />
        <Route path="/catering" element={<CateringNew />} />
        {/* <Route path="/catering" element={<ProtectedRoute element={<Catering />} />} />
        <Route path="/catering-booking" element={<ProtectedRoute element={<CateringBooking />} />} /> */}
        <Route path="/order-online/:slug?" element={<ProtectedRoute element={<OrderOnline />} />} />
        <Route path="/order-online/search/:slug?" element={<ProtectedRoute element={<OrderOnline />} />} />
        
        <Route path="/search-result/:slug" element={<ProtectedRoute element={<SearchResult />} />} />

        <Route path="/account" element={<ProtectedRoute element={<AccountOverview />} />} />
        <Route path="/account/profile" element={<ProtectedRoute element={<Profile />} />} />
        <Route path="/account/orders" element={<ProtectedRoute element={<MyOrder />} />} />
        <Route path="/account/address" element={<ProtectedRoute element={<Address />} />} />
        <Route path="/account/wallet" element={<ProtectedRoute element={<UserWallet />} />} />
        <Route path="/account/change-password" element={<ProtectedRoute element={<Changepassword />} />} />
        <Route path="/account/about-us" element={<ProtectedRoute element={<AboutUs />} />} />
        <Route path="/account/help-support" element={<ProtectedRoute element={<Helpsupport />} />} />

        <Route path="/order-details/:id" element={<ProtectedRoute element={<Orderdetails />} />} />
        <Route path="/choose-meal-date" element={<ProtectedRoute element={<ChooseMealData />} />} />
        <Route path="/checkout" element={<ProtectedRoute element={<Checkout />} />} />
        <Route path="/payment" element={<ProtectedRoute element={<Payment />} />} />
        <Route path="/thankyou/:orderid" element={<ProtectedRoute element={<Thankyou />} />} />
        
        
        <Route path="/contact-us" element={<ProtectedRoute element={<ContactUs />} />} />
        <Route path="/:slug" element={<ProtectedRoute element={<Pages />} />} />
        <Route path="/error_404" element={<ProtectedRoute element={<PageNotFound />} />}/>
      </Routes>
    </Router>



  );
}

export default App;
